document.addEventListener("DOMContentLoaded", function () {
    var swiper = new Swiper(".main-slider", {
        slidesPerView: 3,
        loop: true,
        spaceBetween: 25,
        navigation: {
            nextEl: ".swiper-button-next",
            prevEl: ".swiper-button-prev",
        },
        breakpoints: {
            768: { slidesPerView: 5 }
        },
        autoplay: false // Autoplay disabled initially
    });

    var overlaySwiper = new Swiper(".overlay-swiper", {
        loop: true,
        navigation: {
            nextEl: ".overlay-swiper .swiper-button-next",
            prevEl: ".overlay-swiper .swiper-button-prev",
        }
    });

    var overlay = document.querySelector(".overlay-slider");
    var closeBtn = document.querySelector(".close-overlay");

    document.querySelectorAll(".slide-image").forEach((img, index) => {
        img.addEventListener("click", function () {
            overlay.style.display = "flex";
            document.body.style.overflow = "hidden";
            overlaySwiper.slideTo(index);
        });
    });

    closeBtn.addEventListener("click", function () {
        overlay.style.display = "none";
        document.body.style.overflow = "";
    });

    var nextArrow = document.querySelector(".main-slider .swiper-button-next");
    var prevArrow = document.querySelector(".main-slider .swiper-button-prev");

    var nextInterval, prevInterval;

    function startMoveNext() {
        clearInterval(nextInterval);
        clearInterval(prevInterval);
        swiper.autoplay.start();
        nextInterval = setInterval(() => swiper.slideNext(), 500);
    }

    function startMovePrev() {
        clearInterval(nextInterval);
        clearInterval(prevInterval);
        swiper.autoplay.start();
        prevInterval = setInterval(() => swiper.slidePrev(), 500);
    }

    function stopMove() {
        clearInterval(nextInterval);
        clearInterval(prevInterval);
        swiper.autoplay.stop();
    }

    nextArrow.addEventListener("mouseenter", startMoveNext);
    nextArrow.addEventListener("mouseleave", stopMove);
    prevArrow.addEventListener("mouseenter", startMovePrev);
    prevArrow.addEventListener("mouseleave", stopMove);
});